var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m6 12.494a0.5 0.5 0 0 0 0.16797 0.37891 0.5 0.5 0 0 0 0.70508-0.04102l4-4.5a0.50005 0.50005 0 0 0 0-0.66406l-4-4.5a0.5 0.5 0 0 0-0.70508-0.04102 0.5 0.5 0 0 0-0.041016 0.70508l3.7031 4.168-3.7031 4.168a0.5 0.5 0 0 0-0.12695 0.32617z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#bfbfbf",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.e0e17eadb68e2616013354324f3be8b2.svg";
export { ForwardRef as ReactComponent };